import { lazy } from 'react';

export const Dashboard = lazy(() => import('./Dashboard'));
export const StudentDashboard = lazy(() => import('./StudentDashboard'));